import { auth } from '../firebase'
import { Location, Route } from 'vue-router'

const waitForAuth = () => {
  return new Promise((resolve, reject) => {
    auth().onIdTokenChanged(resolve, reject)
  })
}

export default (to: Route, from: Route, next: (to?: string | false | void | Location | ((vm: Vue) => any) | undefined) => void) => {
  waitForAuth().then(user => {
    window.console.log(user, to.path, to.meta.requiresAuth)
    if (user) {
      if (to.meta.requiresAuth) {
        next()
      } else if (['/login', '/register'].indexOf(to.path) > -1) {
        next('/')
      } else {
        next()
      }
    } else {
      if (to.meta.requiresAuth) {
        next('/login')
      } else {
        next()
      }
    }
  })
}
